import { Box, Text } from '@chakra-ui/react'
import { FaCheckCircle, FaWarehouse } from 'react-icons/fa'
import { colors } from '../../../../utilities/colors'
import HighlightMatch from '../../../../utilities/HighlightMatch'

export default function LocationCard({ loc, accent, isSelected, onClick, match }) {
  const clickable = typeof onClick === 'function'
  return (
    <Box
      as={clickable ? 'button' : 'div'}
      onClick={clickable ? onClick : undefined}
      w="full"
      p={3}
      borderRadius="md"
      border="1px solid"
      borderColor={isSelected ? accent : colors.grey700}
      bg={isSelected ? `${accent}15` : colors.grey900}
      textAlign="left"
      _hover={clickable ? { borderColor: accent, cursor: 'pointer' } : undefined}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
    >
      {loc.isPrimary && (
        <Box flexShrink={0} color={colors.green} display="flex" alignItems="center">
          <FaWarehouse />
        </Box>
      )}
      <Box minW={0} flex={1}>
        {loc.name && (
          <Text as="div" fontSize="sm" fontWeight="semibold" color={colors.grey100} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
            <HighlightMatch str={loc.name} match={match} truncate />
          </Text>
        )}
        {loc.address && (
          <Text as="div" fontSize="xs" color={colors.grey300} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
            <HighlightMatch str={loc.address} match={match} truncate />
          </Text>
        )}
        <Text as="div" fontSize="xs" color={colors.grey300}>
          <HighlightMatch str={`${loc.city}, ${loc.state} ${loc.postal_code}`} match={match} />
        </Text>
      </Box>
      {isSelected && <FaCheckCircle color={accent} />}
    </Box>
  )
}
